import styles from "./Section6.module.scss";

export const Section6 = function () {
  return (
    <section id="conveners-section" className={`${styles.section6Wrapper} cc--component-container`}>
      <h3>Your Course Conveners</h3>
      <div className={styles.section6Container}>
        <div className={styles.section6Content}>
          <div className={`${styles.photo} ${styles.image}`} />
          <div className={styles.name}>
            <p>Robert A. Lue</p>
            <p>
              <i>The Late Richard L. Menschel Faculty Director, Harvard’s Derek Bok Center for Teaching and Learning</i>
            </p>
          </div>
          <div className={styles.summary}>
            <p>
              As a professor in the Department of Molecular and Cellular Biology, Lue was responsible for fostering
              innovative teaching in the Faculty of Arts and Sciences and elevating its profile on campus. Lue earned
              his Ph.D. in biology from Harvard and had taught undergraduate courses since 1988, garnering recognition
              as one of the University’s foremost leaders in undergraduate education.
            </p>
            <p>
              Lue had a longstanding commitment to interdisciplinary teaching and research. From 2004 to 2015, he served
              as the director of life sciences education at Harvard, where he led a complete redesign of the
              introductory curriculum that created some of the largest and most popular science courses on campus.
            </p>
            <p>
              In 2012, Lue’s extensive work on using technology to enhance learning took a new direction when he became
              the faculty director of HarvardX. At HarvardX, the university-wide initiative that includes the edX
              partnership in online education with MIT, Professor Lue helped shape the University’s engagement in online
              learning in a way that reinforces its commitment to teaching excellence and works to expand its reach and
              impact globally. In addition, as the now former faculty director of the Harvard Ed Portal, Lue oversaw the
              integration of undergraduate education with community outreach on Harvard’s Allston campus. Professor Lue
              passed away in 2020 and is thanked for his contribution to his academic field.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
